// Size chart content - Handles the country selector and tabs content
if(!customElements.get("size-chart-content")) {
  customElements.define("size-chart-content", class extends HTMLElement {
    constructor() {
      super();
      
      // Country selector
      this.countrySelector = this.querySelector(".size-chart-select");
      this.countrySelectorTrigger = this.querySelector(
        ".size-chart-select-trigger"
      );
      this.countrySelectorLabelText = this.querySelector(
        ".size-chart-select-label-text"
      );

      // Country selector options
      this.countryItemsWrapper = this.querySelector(
        ".size-chart-select-options-wrapper"
      );
      this.countryOptions = this.querySelector(".size-chart-select-options");
      this.isCountrySelectorOpen = false;
      this.currentCountry = this.countrySelector?.dataset?.selectedCountry || "us";

      this.toggleDropdown = this.toggleDropdown.bind(this);
      this.handleCountryChange = this.handleCountryChange.bind(this);

      // TABS
      this.tabs = this.querySelectorAll(".size-chart-tab");
      this.currentChartType = this.querySelector(
        ".size-chart-tab.selected"
      )?.dataset?.type;
      this.sizeCharts = this.querySelectorAll(".size-chart-tabs-content");

      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
       // Country selector
       this.setDropdownFullHeight();
       this.countrySelectorTrigger.addEventListener(
         "click",
         this.toggleDropdown
       );

       this.countryOptions.addEventListener(
         "click",
         this.handleCountryChange
       );

       document.addEventListener("click", (e) => {
         if (!this.countrySelector.contains(e.target)) {
           this.closeDropdown();
         }
       });

       // Tabs
       this.tabs.forEach((tab) => {
         tab.addEventListener("click", this.handleTabClick);
       });
    }

    setDropdownFullHeight() {
      this.optionsFullHeight = this.countryOptions.offsetHeight;
    }

    toggleDropdown(event) {
      event.preventDefault();
      event.stopPropagation();

      this.isCountrySelectorOpen = !this.isCountrySelectorOpen;
      this.countrySelector.classList.toggle(
        "active",
        this.isCountrySelectorOpen
      );
      this.countryItemsWrapper.style.height = this.isCountrySelectorOpen
        ? `${this.optionsFullHeight}px`
        : "0px";
    }

    closeDropdown() {
      if (this.isCountrySelectorOpen) {
        this.isCountrySelectorOpen = false;
        this.countrySelector.classList.remove("active");
        this.countryItemsWrapper.style.height = "0px";
      }
    }

    handleCountryChange(event) {
      if (event.target == this.countryOptions) return;

      const targetInput = event.target.classList.contains("size-chart-select-option") ?
        event.target : event.target.closest(".size-chart-select-option");

      const selectedCountry = targetInput?.dataset?.value;
      const defaultMeasurementUnit = targetInput?.dataset?.defaultMeasurementUnit;

      if (!selectedCountry) return;

      this.closeDropdown();
      
      if(selectedCountry == this.currentCountry)  return
      this.currentCountry = selectedCountry;
      
      this.updateAvailableTabs();
      this.updateTriggerLabel(targetInput.textContent);

      if(this.countrySelector) 
      this.countrySelector.dataset.selectedCountry = selectedCountry;

      publish(PUB_SUB_EVENTS.sizeChartCountryChange, {selectedCountry, defaultMeasurementUnit});
    }

    updateTriggerLabel(content){
      this.countrySelectorLabelText.textContent = content;

      const flagImage = this.countrySelectorTrigger.querySelector(".flag-image > img");
      if(!flagImage) return;

      flagImage.alt = content.trim();
      ['src', 'srcset'].forEach(attr => {
        if(flagImage[attr]) {
          flagImage[attr] = flagImage[attr].replace(/\/flags\/([a-z]{2,3})\.svg/, `/flags/${this.currentCountry.toLowerCase()}.svg`);
        }
      });
    }

    updateAvailableTabs() {
      const [avaialableTabs, unavailableTabs] = Array.from(this.tabs).reduce(
        (acc, tab) => {
          if (tab.dataset.availableCountries.includes(this.currentCountry)) {
            acc[0].push(tab);
            tab.classList.remove("hidden");
          } else {
            acc[1].push(tab);
            tab.classList.add("hidden");
          }
          return acc;
        },
        [[], []]
      );

      const unavailableSelectedTab = unavailableTabs.find((tab) =>
        tab.classList.contains("selected")
      );
      if (unavailableSelectedTab) {
        unavailableSelectedTab.classList.remove("selected");

        const firstAvailableTab = avaialableTabs[0];
        const firstAvailableTabType = firstAvailableTab.dataset.type;

        if (!firstAvailableTabType) return;
        firstAvailableTab.classList.add("selected");
        this.currentChartType = firstAvailableTabType;
        this.updateTabContent();
      }
    }

    handleTabClick(event) {
      const targetTab = event.target;
      if (targetTab.classList.contains("selected")) return;

      this.tabs.forEach((tab) => {
        tab.classList.remove("selected");
      });

      targetTab.classList.add("selected");

      const targetTabType = targetTab.dataset.type;
      this.currentChartType = targetTabType;
      this.updateTabContent();
    }

    updateTabContent() {
      this.sizeCharts.forEach((sizeChart) => {
        const chartType = sizeChart.dataset.type;
        if (chartType !== this.currentChartType) {
          sizeChart.classList.add("hidden");
        } else {
          sizeChart.classList.remove("hidden");
        }
      });
    }

    disconnectedCallback() {
      if(this.countrySelectorTrigger) {
        this.countrySelectorTrigger.removeEventListener("click", this.toggleDropdown);
      }

      if(this.countryOptions) {
        this.countryOptions.removeEventListener("click", this.handleCountryChange);
      }

      if(this.tabs?.length) {
        this.tabs.forEach((tab) => {
          tab.removeEventListener("click", this.handleTabClick);
        });
      }
    }
  });
}

// Size chart table - Handles the unit toggle, country specific rows and table cell hover
if (!customElements.get("size-chart-table")) {
  customElements.define("size-chart-table", class extends HTMLElement {
    constructor() {
      super();

      this.unitToggle = this.querySelector(".unit-toggle-input");
      this.currentUnit = this.unitToggle?.checked ? "inch" : "cm";
      this.unitChangingRows = this.querySelectorAll(".unit-row");
      this.countrySpecificRows = this.querySelectorAll(".specific-country-row");

      this.handleUnitSwitchClick = this.handleUnitSwitchClick.bind(this);

      // Main table
      this.tableBody = this.querySelector(".size-guide-table tbody");
      this.tableDataCells = this.querySelectorAll(".size-guide-table tbody tr td");
      this.headerRow = this.querySelectorAll(".size-guide-table .size-guide-table-header");
      this.bodyRows = this.querySelectorAll(".size-guide-table tbody tr");

      // Additional table
      this.additionalTableBody = this.querySelector(".additional-table-wrapper .additional-table tbody");
      this.additionalTableDataCells = this.querySelectorAll(".additional-table tbody tr td");
      this.additionalTableHeaderRow = this.querySelectorAll(".additional-table .additional-table-header");
      this.additionalTableBodyRows = this.querySelectorAll(".additional-table tbody tr");

      // Fit guide buttons
      this.fitGuideButtonLabels = this.querySelectorAll(".fit-guide-button-label");
    }

    connectedCallback() {
      this.unitToggle.addEventListener("change", this.handleUnitSwitchClick);

      this.countryChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.sizeChartCountryChange, (event) => {
        this.updateCountrySpecificRows(event.selectedCountry);
        this.updateUnitToggle(event.defaultMeasurementUnit);
      });

      const mainTableConfig = {
        selector: '.size-guide-table',
        bodyRows: this.bodyRows,
        headerRows: this.headerRow
      };

      const additionalTableConfig = {
        selector: '.additional-table',
        bodyRows: this.additionalTableBodyRows,
        headerRows: this.additionalTableHeaderRow
      };

      this.tableDataCells.forEach((cell) => {
        cell.addEventListener('mouseover', (e) => this.handleTableCellHover(e, mainTableConfig));
      });
      this.tableBody.addEventListener('mouseleave', () => this.handleTableBodyLeave(mainTableConfig));

      if (this.additionalTableBody) {
        this.additionalTableBody.addEventListener('mouseleave', () => 
          this.handleTableBodyLeave(additionalTableConfig)
        );
      }

      if (this.additionalTableDataCells) {
        this.additionalTableDataCells.forEach((cell) => {
          cell.addEventListener('mouseover', (e) => 
            this.handleTableCellHover(e, additionalTableConfig)
          );
        });
      }
    }

    handleTableCellHover(e, tableConfig) {
      const cell = e.target;
      const hoveredIndex = +cell.dataset?.cellindex;

      const relatedCells = this.querySelectorAll(`${tableConfig.selector} .related-cell`);
      relatedCells.forEach(cell => cell.classList.remove('related-cell'));

      const bodyRows = Array.from(tableConfig.bodyRows);
      const currentRowIndex = bodyRows.indexOf(cell.closest("tr"));

      // Process rows above current row which are visible
      bodyRows.slice(0, currentRowIndex).forEach(row => {
        if (!row.checkVisibility()) return;
        row.querySelector(`td:nth-child(${hoveredIndex+1})`).classList.add('related-cell');
      });

      // Process header rows
      tableConfig.headerRows.forEach(row => {
        const headers = row.querySelectorAll('th');
        headers[hoveredIndex]?.classList.add('related-cell');
      });
    }

    handleTableBodyLeave(tableConfig) {
      this.querySelectorAll(`${tableConfig.selector} .related-cell`)
        .forEach(el => el.classList.remove('related-cell'));
    }

    handleUnitSwitchClick(e) {
      if(e.target.tagName !== "INPUT") return;
      e.stopPropagation();

      const unit = e.target.checked ? "inch" : "cm";

      this.updateUnitToggle(unit);
    }

    updateUnitToggle(unit){
      if (unit === this.currentUnit) return;

      this.unitToggle.checked = unit === "inch";
      this.currentUnit = unit;

      if (this.unitChangingRows.length > 0) {
        this.unitChangingRows.forEach((row) => {
          const rowUnit = row.dataset.unit;
          if (rowUnit === unit) {
            row.classList.remove("hidden");
          } else {
            row.classList.add("hidden");
          }
        });
      }

      if(this.fitGuideButtonLabels.length) {
        this.fitGuideButtonLabels.forEach((label) => {
          const labelUnit = label.dataset.unit;
          if(labelUnit === unit) {
            label.classList.remove("hidden");
          } else {
            label.classList.add("hidden");
          }
        });
      }
    }

    updateCountrySpecificRows(currentCountryIso) {
      if(!currentCountryIso || !this.countrySpecificRows.length) return;

      this.countrySpecificRows.forEach((row) => {
        const rowCountry = row.dataset.countryIso;
        if (rowCountry.toLowerCase() === currentCountryIso.toLowerCase()) {
          row.classList.remove("hidden");
        } else {
          row.classList.add("hidden");
        }
      });
    }

    disconnectedCallback() {
      if(this.countryChangeUnsubscriber) {
        this.countryChangeUnsubscriber();
      }

      if (this.unitToggle){
        this.unitToggle.removeEventListener("change", this.handleUnitSwitchClick);
      }

      if (this.tableBody) {
        this.tableBody.removeEventListener("mouseleave", this.handleTableBodyLeave);
      }

      if(this.tableDataCells) {
        this.tableDataCells.forEach((cell) => {
          cell.removeEventListener("mouseover", this.handleTableCellHover);
        });
      }
    }
  });
}

// Fit guide - Handles the fit guide buttons and content updates
if (!customElements.get("fit-guide")) {
  customElements.define("fit-guide", class extends HTMLElement {
    constructor() {
      super();

      this.fitGuideButtons = this.querySelectorAll(".fit-guide-button");
      this.fitGuideOptionValues = this.querySelectorAll(".fit-guide-option-value");

      this.selectedFitGuideIndex = this.querySelector(".fit-guide-button.selected")?.dataset?.index;

      this.handleFitGuideButtonClick = this.handleFitGuideButtonClick.bind(this);
    }

    connectedCallback() {
      this.fitGuideButtons.forEach((button) => {
        button.addEventListener("click", this.handleFitGuideButtonClick);
      });
    }

    handleFitGuideButtonClick(e) {
      const targetButton = e.target.tagName !== "BUTTON" ? e.target.closest(".fit-guide-button") : e.target;
      if (!targetButton) return;

      const targetButtonIndex = +targetButton.dataset.index;
      if(targetButtonIndex === this.selectedFitGuideIndex) return;

      this.fitGuideButtons.forEach((button) => {
        button.classList.remove("selected");
      });
      targetButton.classList.add("selected");

      this.selectedFitGuideIndex = targetButtonIndex;
      
      this.fitGuideOptionValues.forEach((value) => {
        const index = +value.dataset.index;
        if(index === this.selectedFitGuideIndex) {
          value.classList.remove("hidden");
        } else {
          value.classList.add("hidden");
        }
      });
    }

    disconnectedCallback() {
      if(this.fitGuideButtons) {
        this.fitGuideButtons.forEach((button) => {
          button.removeEventListener("click", this.handleFitGuideButtonClick);
        });
      }
    }
  });
}